import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With over 15 years of experience in cybersecurity and your current leadership role
                at MEDGULF, you’ve witnessed the rapid evolution of cyber threats and compliance
                demands. How do you ensure that MEDGULF’s cybersecurity strategy remains agile and
                aligned with both emerging threats and changing regulatory landscapes in the
                insurance sector?
              </strong>
            </h5>

            <h5 className="text-white">
              Ensuring agility in our cybersecurity strategy at MEDGULF involves a proactive,
              multi-layered approach. Leveraging my 15+ years in cybersecurity, we continuously
              monitor the evolving threat landscape through robust threat intelligence feeds and
              regular vulnerability assessments of critical systems, enabling rapid adaptation and
              response.
              <br />
              <br />
              Crucially, we align our cybersecurity strategy closely with both business objectives
              and stringent regulatory requirements mandated by the Insurance Authority, including
              adherence to the SAMA Cyber Security Framework (CSF) and the SAMA Business Continuity
              Management (BCM) Framework. My role encompasses oversight of cybersecurity risk
              activities, development of comprehensive security programs, and rigorous compliance
              management, including frameworks such as SAMA CSF and NCA ECC. We regularly update
              policies, standards, and controls to address emerging threats and maintain compliance.
              Additionally, periodic reporting of our security posture and risk indicators to
              executive management ensures strategic alignment and responsiveness.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As someone who bridges cybersecurity and enterprise strategy, your role plays a
                crucial part in digital transformation. How do you integrate cybersecurity risk
                considerations into MEDGULF’s broader digital initiatives, particularly when
                balancing innovation with security?
              </strong>
            </h5>
            <h5 className="text-white">
              Integrating cybersecurity into digital transformation initiatives is fundamental to
              maintaining organizational resilience and enabling innovation. At MEDGULF,
              cybersecurity considerations are embedded from the inception of every digital
              initiative. My experience includes leading digital transformation projects where
              security architecture and controls are strategically aligned with enterprise goals. We
              conduct comprehensive cybersecurity risk assessments for new initiatives and
              significant system changes, thoroughly evaluating impacts on confidentiality,
              integrity, and availability. Collaborating closely with innovation teams, we ensure
              security-by-design principles are embedded into project architectures, rather than
              being retroactively addressed. By actively participating in strategic committees, we
              ensure cybersecurity risk considerations remain integral to MEDGULF’s innovation
              strategy, ultimately enhancing customer trust and regulatory compliance.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-Cyber Governance, Risk, and Compliance (GRC) is increasingly being recognized as a
                business enabler rather than just a control function. What practices or frameworks
                have you implemented to elevate GRC from a regulatory requirement to a driver of
                organizational resilience and trust at MEDGULF?
              </strong>
            </h5>
            <h5 className="text-white">
              At MEDGULF, GRC is strategically positioned as a business enabler. Beyond basic
              compliance with frameworks such as SAMA CSF, our GRC practices focus on building
              organizational resilience and enhancing stakeholder trust. Our key practices include:
              <br />
              <ul>
                <li>
                  Risk-Based Approach: Establishing comprehensive risk management processes tailored
                  specifically to MEDGULF’s business operations, proactively identifying, assessing,
                  and mitigating risks to ensure resilience.
                </li>
                <li>
                  Integrated Governance: Clearly defined governance structures, including dedicated
                  IT and Cybersecurity steering committees, ensure accountability and integrate
                  cybersecurity into broader organizational decision-making. We utilize RACI
                  matrices to clearly assign responsibilities.
                </li>
                <li>
                  Continuous Improvement: Regularly revisiting and refining our GRC framework based
                  on evolving threat intelligence, audit outcomes, and shifting business
                  requirements.
                </li>
                <li>
                  Compliance as a Foundation: Treating mandatory regulatory frameworks as
                  foundational benchmarks to strengthen our overall cybersecurity posture, thereby
                  building greater customer confidence and operational trustworthiness.
                </li>
              </ul>
              <br />
              By deeply integrating GRC into operational processes, we bolster organizational
              resilience and enhance stakeholder confidence.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-The insurance industry is under growing pressure to safeguard sensitive customer
                data while maintaining seamless digital experiences. What are the key challenges you
                face in securing infrastructure and applications, and how do you approach risk
                management without disrupting customer experience?
              </strong>
            </h5>
            <h5 className="text-white">
              Balancing rigorous security measures with an optimal customer experience is a key
              challenge within the insurance industry. At MEDGULF, our primary challenges include:
              <ul>
                <li>
                  Advanced Threats: Safeguarding extensive sensitive customer data against
                  increasingly sophisticated cyber-attacks.
                </li>
                <li>
                  Complex Infrastructure: Protecting an intricate ecosystem comprising both modern
                  cloud-based solutions and legacy systems.
                </li>
                <li>
                  Regulatory Compliance: Continuously meeting stringent data protection regulations
                  established by SAMA and the Insurance Authority.
                </li>
                <li>
                  User Experience: Implementing essential security measures such as multi-factor
                  authentication and data validation without adversely impacting customer
                  convenience.
                </li>
              </ul>
              <br />
              We adopt proactive risk management strategies, emphasizing effective yet minimally
              intrusive security controls. Our approach includes robust vulnerability management,
              endpoint protection, and backend security enhancements designed with transparency.
              Additionally, a customer-centric security support model ensures risk management aligns
              with positive customer interactions.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As cyber threats grow in sophistication, organizations are placing more focus on
                security culture and awareness. What initiatives or strategies have you led at
                MEDGULF to foster a strong cybersecurity culture across departments, and how do you
                measure their impact?
              </strong>
            </h5>
            <h5 className="text-white">
              Cultivating a robust cybersecurity culture is essential for organizational resilience.
              At MEDGULF, key strategies include:
              <ul>
                <li>
                  Regular Training & Awareness: Tailored security awareness programs addressing
                  phishing, social engineering, secure data handling, and password hygiene for
                  different employee roles.
                </li>
                <li>
                  Clear Communication: Frequent dissemination of cybersecurity policies, best
                  practices, and timely threat updates through multiple internal communication
                  channels.
                </li>
                <li>
                  Executive Leadership Buy-in: Active endorsement and engagement from executive
                  management to reinforce cybersecurity's importance throughout the organization.
                </li>
                <li>
                  Interactive and Engaging Formats: Conducting engaging workshops, simulations, and
                  informative newsletters to maintain high employee engagement.
                </li>
              </ul>
              <br />
              <br />
              To measure the effectiveness of our initiatives, we monitor:
              <ul>
                <li>Training completion rates.</li>
                <li>Phishing simulation outcomes, including click and reporting rates.</li>
                <li>The number and nature of user-reported security incidents.</li>
                <li>Employee feedback from cybersecurity awareness surveys.</li>
              </ul>
              <br />
              These metrics enable continuous improvement, ensuring all employees contribute
              effectively to our cybersecurity posture.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
